import { createContext, useContext } from 'react';
import { type OnImportedHandler } from '../../../../components/sdmSalesPersonCodeMappingImportExport';

type HelpersContext = {
    setOnImported: (onImported: OnImportedHandler) => void;
};

const HelperContext = createContext<HelpersContext | null>(null);

export const useSdmModulePageHelpers = () => {
    const context = useContext(HelperContext);

    if (!context) {
        throw new Error('useSdmModulePageHelpers must be used within a proper context provider');
    }

    return context;
};

export default HelperContext;
